import client from './client';

export interface InvitePublic {
  token: string;
  targetUsername: string;
  role: string;
  allowedRoutes: string[] | null;
  roleKeys: string[] | null;
  permissionGrants: string[] | null;
  createdBy: string;
  expiresAt: string;
  consumedAt: string | null;
  createdAt: string;
}

export interface CreateInviteDto {
  targetUsername: string;
  role?: string;
  allowedRoutes?: string[];
  roleKeys?: string[];
  permissionGrants?: string[];
  expiresInHours?: number;
}

export async function getInvite(token: string): Promise<InvitePublic> {
  const res = await client.get<InvitePublic>(`/auth/invites/${encodeURIComponent(token)}`);
  return res.data;
}

export async function acceptInvite(token: string, password: string): Promise<{ success: boolean; username: string }> {
  const res = await client.post<{ success: boolean; username: string }>(
    `/auth/invites/${encodeURIComponent(token)}/accept`,
    { password },
  );
  return res.data;
}

export async function createInvite(dto: CreateInviteDto): Promise<InvitePublic> {
  const res = await client.post<InvitePublic>('/auth/invites', dto);
  return res.data;
}

export async function listInvites(): Promise<InvitePublic[]> {
  const res = await client.get<InvitePublic[]>('/auth/invites');
  return res.data;
}

export async function deleteInvite(token: string): Promise<{ success: boolean }> {
  const res = await client.delete(`/auth/invites/${encodeURIComponent(token)}`);
  return res.data;
}
